// Copyright (C) 2020-2022 Intel Corporation
// Copyright (C) 2024 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React, { useCallback, useState } from 'react';

import { Col, Row } from 'antd';
import { useHistory } from 'react-router';
import { BarChartOutlined, LeftOutlined } from '@ant-design/icons';
import Button from 'antd/lib/button';

import ActionsMenuContainer from 'containers/actions-menu/actions-menu';
import Metrics from 'components/metrics/metrics';

interface DetailsComponentProps {
    taskInstance: any;
}

export default function DetailsComponent(props: DetailsComponentProps): JSX.Element {
    const [isMetricsVisible, setIsMetricsVisible] = useState(false);
    const { taskInstance } = props;

    const history = useHistory();

    const onViewAnalytics = useCallback(() => {
        history.push(`/tasks/${taskInstance.id}/analytics`);
    }, [history]);

    const getMetrics = () => {
        setIsMetricsVisible(true);
    };

    const changeMetricsVisible = (elem: boolean) => {
        setIsMetricsVisible(elem);
    };

    return (
        <Row className='cvat-task-top-bar' justify='space-between' align='middle'>
            <Col>
                {taskInstance.projectId ? (
                    <Button
                        className='cvat-page-actions-button'
                        onClick={() => history.push(`/projects/${taskInstance.projectId}`)}
                        type='default'
                        size='middle'
                    >
                        <LeftOutlined />
                        Назад к проектам
                    </Button>
                ) : (
                    <Button
                        className='cvat-page-actions-button'
                        onClick={() => history.push('/tasks')}
                        type='default'
                        size='middle'
                    >
                        <LeftOutlined />
                        Назад к задачам
                    </Button>
                )}
            </Col>
            <Col style={{display: 'flex'}}>
                <Button
                    className='cvat-page-actions-button'
                    onClick={() => getMetrics()}
                    type='default'
                    size='middle'
                    style={{ marginRight: '10px' }}
                >
                    <BarChartOutlined />
                    Метрики
                </Button>
                <ActionsMenuContainer
                    taskInstance={taskInstance}
                    onViewAnalytics={onViewAnalytics}
                />
                {/* <Dropdown
                    trigger={['click']}
                    destroyPopupOnHide
                    overlay={(
                        <ActionsMenuContainer
                            taskInstance={taskInstance}
                            onViewAnalytics={onViewAnalytics}
                        />
                    )}
                >
                    <Button size='middle' className='cvat-task-page-actions-button'>
                        <Text className='cvat-text-color'>Действия</Text>
                        <MoreOutlined className='cvat-menu-icon' />
                    </Button>
                </Dropdown> */}
            </Col>
            {isMetricsVisible && taskInstance?.id && (
                <Metrics
                    instansName='task_id'
                    instansId={taskInstance.id}
                    changeMetricsVisible={changeMetricsVisible}
                />
            )}
        </Row>
    );
}
